<template>
  <b-carousel indicator-mode="click" indicator-inside indicator-position="is-bottom" indicator-style="is-dots"
    :autoplay="false" ref="carousel">
    <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
      <img :src="carousel.image" class="image-product" />
      <p class="paging">{{ i + 1 }}/{{ carousels.length }}</p>
    </b-carousel-item>
  </b-carousel>
</template>

<script>
export default {
  props: {
    carousels: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    carousels() {
      if (this.$refs.carousel) {
        this.$refs.carousel.activeChild = 0;
      }
    }
  },
}
</script>

<style lang="scss">
.image-product {
  position: relative;
  text-align: center;
  width: inherit;
}
</style>